import { useCallback, useEffect, useRef, useState } from 'react';

import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchLineServices = () => {
  const [loading, setLoading] = useState();
  const [lineServices, setLineServices] = useState([])
  const isMounted = useRef(true)

  const fetchServices = useCallback(async () => {
    setLoading(true);
    if (lineServices.length === 0) {
        try {
          const response = await lineEndpoint.getServices()
          if(response.status === 200) {
            if(isMounted.current) setLineServices(response.data)
          }
        } finally {
          setLoading(false);
        }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchServices().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchServices]);

  return {
    loading,
    lineServices,
  };
};
